import React from "react"

import { InstallationReferenceSelectionOverlayView } from "./InstallationReferenceSelectionOverlayView"
import { InstallationReferenceSelectionOverlayModel } from "./model/useInstallationReferenceSelectionOverlayModel"
import { useInstallationReferenceSelectionOverlayViewModel } from "./model/useInstallationReferenceSelectionOverlayViewModel"

export interface InstallationReferenceSelectionOverlayProps
  extends InstallationReferenceSelectionOverlayModel {}

export const InstallationReferenceSelectionOverlay = React.memo(
  (props: InstallationReferenceSelectionOverlayProps) => (
    <InstallationReferenceSelectionOverlayView
      {...useInstallationReferenceSelectionOverlayViewModel(props)}
    />
  )
)
